import React from 'react';
import { PARTNERSHIP, PARTNERSHIP_PILLARS } from '../content/landingContent';
import FeatureIcon from './FeatureIcon';

/** Compact “why us” grid in the hero — fills space below the main headline row. */
const HeroDifferentiators: React.FC = () => (
  <div id="partnership" className="cp-landing-hero__diffs" aria-labelledby="hero-diffs-title">
    <header className="cp-landing-hero__diffs-head">
      <p className="cp-landing-eyebrow cp-landing-hero__diffs-eyebrow">{PARTNERSHIP.eyebrow}</p>
      <h2 id="hero-diffs-title" className="cp-landing-hero__diffs-title">
        {PARTNERSHIP.title}
      </h2>
      <p className="cp-landing-hero__diffs-lead">{PARTNERSHIP.lead}</p>
    </header>
    <div className="cp-landing-hero__diffs-grid">
      {PARTNERSHIP_PILLARS.map((pillar) => (
        <article key={pillar.id} className="cp-landing-hero-diff">
          <span className="cp-landing-hero-diff__icon-wrap">
            <FeatureIcon iconKey={pillar.iconKey} className="cp-landing-hero-diff__icon" />
          </span>
          <div className="cp-landing-hero-diff__body">
            <h3 className="cp-landing-hero-diff__title">{pillar.title}</h3>
            <p className="cp-landing-hero-diff__text">{pillar.description}</p>
          </div>
        </article>
      ))}
    </div>
  </div>
);

export default HeroDifferentiators;
